// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_UploadRefundReceiptResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_UploadRefundReceiptResponseDados {
blob_name: string
file_url: string
file_name: string
file_size: number
mime_type: string
}

export type Payroll_UploadRefundReceiptResponse = ApiResponse<Payroll_UploadRefundReceiptResponseDados>;

registerResponseContract('Payroll_UploadRefundReceiptResponse', {
  blob_name: { type: 'string',  required: true },
  file_url:  { type: 'string',  required: true },
  file_name: { type: 'string',  required: true },
  file_size: { type: 'number',  required: true },
  mime_type: { type: 'string',  required: true },
})
